import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDIl4AlC-HK6SoI9AymHLz0kkTlqYGW1wU",
  authDomain: "clone-f66e7.firebaseapp.com",
  projectId: "clone-f66e7",
  storageBucket: "clone-f66e7.appspot.com",
  messagingSenderId: "737438890513",
  appId: "1:737438890513:web:31428caa9dc86fe1054fb0",
  measurementId: "G-4L972NGMB8"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider(); //for auth signup

export { auth, provider };
export default db;
